export enum AuthenticationActionTypes {
	SET_AUTHENTICATION_TYPE = "AUTHENTICATION/SET_AUTHENTICATION_TYPE",
	SET_PIN = "AUTHENTICATION/SET_PIN",
	SET_PIN_CODE = "AUTHENTICATION/SET_PIN_CODE",
}
